import angular from 'angular';

class ModalController {

  constructor($rootScope, $window, $compile, $scope, $templateCache, $interval, userService) {
    this.$rootScope = $rootScope;
    this.page = $rootScope.page;
    this.$templateCache = $templateCache;
    this.$window = $window;
    this.$compile = $compile;
    this.$scope = $scope;
    this.$interval = $interval;
    this.$userService = userService;
    this.myModalEl = '';
  }

  $onInit() {
    this.step = 0;
    if(this.onLoadModal && !this.$userService.getCookie(this.cookie) && this.$userService.getQueryParam('email', false)) {
      this.pauseVideo();
      this.initOnLoadModal();
    } else {
      this.playVideo();
    }
  }

  optin() {
    import(
      /* webpackMode: "lazy" */
      /* webpackChunkName: "modal" */
      './modal'
    ).then(modalService => {
      this.myModalEl = new modalService.default();
      this.myModalEl.initModal();
    });
  }

 initOnLoadModal() {
   import(
      /* webpackMode: "lazy" */
      /* webpackChunkName: "modal" */
      './modal'
    ).then(modalService => {
      this.myModalEl = new modalService.default();
      this.myModalEl.initModal();
      this.modal = document.getElementById('modal');
      this.modal.innerHTML = this.$templateCache.get('modal.html');
      this.step = 1;
      this.$compile(this.modal)(this.$scope);
      this.$rootScope.$apply();
      this.modal.addEventListener('hidden.bs.modal', () => this.playVideo());
    });
  }

  return(result) {
    if(result) {
      this.$userService.setCookie(this.cookie, result, 365);
      this.myModalEl.hideModal();
    }
  }

  playVideo() {
    this.playinterval = this.$interval(() => {
      if(this.$rootScope.page.wistia) {
        this.$interval.cancel(this.playinterval);
        if(this.$rootScope.page.wistia.state() != "playing") {
          this.$rootScope.page.wistia.replaceWith(this.page.header.video, {autoPlay:true, transition: "fade"});
          this.$rootScope.page.wistia.play();
        }
      }
    }, 200);
  }

  pauseVideo() {
    this.pauseinterval = this.$interval(() => {
      if(this.$rootScope.page.wistia) {
        this.$interval.cancel(this.pauseinterval);
        this.$rootScope.page.wistia.pause();
      }
    }, 200);
  }

  selectSurvey(key, value) {
    var email = this.$userService.getQueryParam('email');
    var property = {};
    property[key] = value;
    this.$userService.saveHSProperty(email, property).then((result)=>{
      if(result.data.status == 'ok' && this.step == 1) {
          this.step = 2;
      } else {
        this.return(true);
      }
    })
  }

}

ModalController.$inject = ["$rootScope", "$window", "$compile", "$scope", "$templateCache", "$interval", "userService"];

class ModalComponent {
  constructor() {
    this.bindings = {
      formtarget: '@?',
      form: '@?',
      redirect: '@?',
      onLoadModal: '@?',
      cookie: '@?'
    };
    // this.template = template;
    this.controller = ModalController;
  }
}

export default angular
.module('mlrmodal.component', [])
.component('mlrmodal', new ModalComponent())
.name;